// In-memory holder for the current tenant's public config.
//
// index.js resolves the tenant config (from the sessionStorage cache and/or the
// /api/order/tenant-config fetch) at boot and pushes the `links` here via
// setTenantConfig; OrderPage.js reads them with getTenantLinks to build the
// Need-help box hrefs. Kept out of React state on purpose: these are read once
// at render, never re-render on change, and OrderPage sits below the render gate
// so the config is already applied by the time it mounts.
//
// The defaults mirror the API's tenantConfig defaults, so the box renders
// correct PartsVu links even if the config fetch is skipped or fails.
let config = {
  links: {
    contact: '/pages/contact',
    shippingPolicy: '/pages/shipping-returns',
  },
};

// Overlay a partial config onto the current one. `links` is merged key-by-key
// over the existing links (NOT replaced), so a tenant-config response that omits
// `links` — or omits an individual link — keeps the defaults for what it leaves
// out.
export const setTenantConfig = (c = {}) => {
  config = {
    ...config,
    ...c,
    links: {
      ...config.links,
      ...(c.links || {}),
    },
  };
};

export const getTenantLinks = () => config.links;
